<template>
  <div class="animated fadeIn">
    <div id="accueil-eb">
      <b-row>
        <b-col md="12">
          <h1 class="display-3">Adhésion en ligne</h1>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../../utils/auth'

export default {
  data() {
    return {
      
    }
  },
  mounted() {

  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl()
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json'
    this.$axios.defaults.headers.common['Provider'] = getProvider()
  },
  methods: {

  }
}
</script>